import styled, { css } from 'styled-components';
import { ModalDialog } from '@zillow/constellation';

const notificationTransitionOut = 'opacity 0.5s 1.0s ease-in, background .4s ease-out';
const notificationTransitionIn = 'opacity 0.2s ease-in, background .4s ease-out';

export const StyledImageCarouselModal = styled(ModalDialog)(({ theme }) => css`
    .ImageCarousel {
        position: relative;
    }

    .ImageCarouselModal-Form {
        padding: ${theme.ns().spacing.sm()} ${theme.ns().spacing.sm()} ${theme.ns().spacing.lg()};

        ${theme.ns().media.lg(css`
            padding: ${theme.ns().spacing.md()} ${theme.ns().spacing.getSpacing(6)} ${theme.ns().spacing.getSpacing(6)};
        `)}
    }

    .ImageCarouselModal-Form-Textarea {
        &.disabled {
            opacity: .3;
            pointer-events: none;
        }
    }

    .ImageCarouselModal-Form-Actions {
        display: flex;
        flex-direction: row;
        align-items: center;

        /* // TODO: abstract status messages (util, component...) */
        .Status {
            opacity: 0;
            transition: ${notificationTransitionOut};
        }

        .Status-processing {
            opacity: 1;
            transition: ${notificationTransitionIn};
        }
        .Icon-Rotate-Container {
            margin-left: auto;
            cursor: pointer;
        }
        .Icon-Rotate-Container-disabled {
            pointer-events: none;
        }
    }
`);
